type StreamPayloadLike = {
  pipeline?: unknown;
  repair?: unknown;
  repairAppendix?: unknown;
  quota?: unknown;
  offTopic?: boolean;
  progressState?: unknown;
  thinking?: string;
  reasoning?: string;
  text?: string;
};

export function hasDisplayPayloadAfterMetadata(chunk: StreamPayloadLike): boolean {
  return Boolean(
    chunk.pipeline
      || chunk.repair
      || chunk.repairAppendix
      || chunk.quota
      || chunk.offTopic === true
      || chunk.progressState
      || chunk.thinking
      || chunk.reasoning
      || chunk.text
  );
}

/**
 * Whether a chunk carrying a pipeline still has something else to be handled.
 *
 * The worker bundles a whole terminal state into one chunk, so the pipeline
 * routinely shares a chunk with the payload that explains it. The clearest case
 * is a repair the stage graph refused to run: `{ metadata, pipeline,
 * repairAppendix, progressState, quota, done }` is published as a single
 * message, and the appendix is the only account of *why* nothing was repaired.
 * Stopping at the pipeline dropped it, and the browser then had a repair stage
 * that had started and finished with nothing to say — no conclusion, no rounds,
 * no blocked card — which the step stream drops as a stage that produced
 * nothing. The row vanished from the turn between the preflight and the
 * compiler, along with the reason it was there.
 *
 * `quota` and `progressState` are deliberately absent: their handlers run
 * *before* the pipeline branch, so they are already spent by the time this is
 * asked. This lists only what is still ahead in the loop.
 */
export function hasDisplayPayloadAfterPipeline(chunk: StreamPayloadLike): boolean {
  return Boolean(
    chunk.repairAppendix
      || chunk.repair
      || chunk.offTopic === true
      || chunk.thinking
      || chunk.reasoning
      || chunk.text
  );
}
